var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImpecc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 15,
    viewBox: "0 0 26 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0962 7.40839C12.9501 11.0541 10.2624 14.356 6.26357 14.356C0.815204 14.356 0.20413 10.8718 0.204102 8.23637C0.30879 5.16098 2.20474 3.2295 4.33594 2.87614C5.8419 2.62645 7.62813 3.20246 8.2658 4.55358V3.26052H10.2469V7.40839H8.2658C7.13221 3.97636 2.59145 4.42564 2.32649 8.53827C2.1942 11.4289 4.01264 12.4205 6.26348 12.4205C9.0974 12.168 11.0126 9.72483 11.9411 7.40839H14.0962Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8706 7.59259C13.0166 3.9469 15.7381 0.644997 19.7369 0.644997C25.1853 0.644998 25.7964 4.12915 25.7964 6.76461C25.6917 9.84 23.7957 11.7715 21.6645 12.1248C20.1586 12.3745 18.3724 11.7985 17.7347 10.4474L17.7347 11.7405L15.7536 11.7405L15.7536 7.59259L17.7347 7.59259C18.8683 11.0246 23.409 10.5753 23.674 6.4627C23.8063 3.57212 21.9879 2.58047 19.737 2.58047C16.9031 2.83297 14.965 5.27615 14.0364 7.59259L11.8706 7.59259Z",
    fill: "#FF823C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpecc);
export default __webpack_public_path__ + "static/media/impecc.6859524aea4224d7abd27b92add9ada1.svg";
export { ForwardRef as ReactComponent };